var map = {
	"./SkinAlex64x64.png": 94553,
	"./SkinAlexReference64x64.png": 78947,
	"./SkinSteve64x64.png": 68603,
	"./SkinSteveDiamondArmor256x256.png": 27235,
	"./SkinSteveDiamondArmor64x64.png": 55310,
	"./SkinSteveReference64x64.png": 99589
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10184;